/* eslint-disable no-console -- this service exists to dump debug state to the console */
import { Injectable, effect, inject } from '@angular/core'
import { Router, NavigationEnd } from '@angular/router'
import { filter } from 'rxjs/operators'

import { NavigationService } from './navigation.service'
import { SessionService } from './session.service'

@Injectable({ providedIn: 'root' })
export class DebuggerService {
  // ────────────────
  // Injected services
  // ────────────────
  private readonly nav = inject(NavigationService)
  private readonly session = inject(SessionService)
  private readonly router = inject(Router)

  // ────────────────
  // 1) Dump all your key signals whenever anything they depend on changes
  // ────────────────
  private readonly _debugState = effect(() => {
    console.groupCollapsed(
      '%c🛠️ DebuggerService State',
      'color:#3a86ff;font-weight:bold',
    )
    console.log('📦 Package ID:          ', this.nav.packageId())
    console.log('🌍 Environment ID:      ', this.nav.environmentId())
    console.log('🔧 Tool ID:            ', this.nav.toolId())
    console.log('🔍 Query ID:           ', this.nav.queryId())
    console.log('⭐ Selected Query ID:   ', this.nav.selectedQueryId())
    console.log(
      '🔀 Pivot Path:         ',
      this.nav.pivotPath().join(',') || '(empty)',
    )
    console.log(
      '✏️ Selected Edit Sec:   ',
      this.nav.selectedEditReportSection(),
    )
    console.log(
      '📄 Selected Final Sec:  ',
      this.nav.selectedFinalReportSection(),
    )
    console.groupEnd()
  })

  // ────────────────
  // 2) Log every NavigationEnd and then dump full route history
  // ────────────────
  private readonly _navLog = this.router.events
    .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
    .subscribe(async (e) => {
      console.log(`➡️ NavigationEnd → URL: ${e.urlAfterRedirects}`)
    })

  // ────────────────
  // 3) Log when the session actually loads a hunt
  // ────────────────
  private readonly _loadLog = effect(() => {
    const hunt = this.session.activeHunt()
    if (hunt) {
      console.log('🔄 SessionService loaded hunt:', hunt.id)
    }
  })
}
